import type { CostMarginsResponse, CostMarginUpdate } from '@/types/Models/CostMargin'
import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class CostMarginsProxy extends BaseProxy implements ProxyMethods<CostMarginsResponse> {
  public endpoint: string

  constructor(companyId: string) {
    super()
    this.endpoint = `companies/${companyId}/cost-margins`
  }

  save(margins: CostMarginUpdate[]): Promise<CostMarginsResponse> {
    return this.submit('put', `/${this.endpoint}`, { margins })
  }
}
